<script setup lang="ts">
import { addUtm } from '../../utils/utmParameter';

// Component Logic
const cdn = import.meta.env.VITE_CDN_MWP_BASE_URL
</script>

<template>
  <section class="bg-sandstone/40 no-print py-20">
    <div class="mx-auto max-w-7xl px-8 xl:px-0">
      <div class="flex justify-start">
        <a :href="addUtm('/')" class="-ml-2">
          <img :src="`${cdn}/logos/MWP-logo-2.svg`" alt="My Wealth Private Logo" />
        </a>
      </div>

      <div
        class="border-b border-off-black grid grid-cols-1 gap-y-12 sm:grid-cols-2 sm:gap-x-8 md:grid-cols-3 md:gap-y-12 md:gap-x-12 lg:grid-cols-6 lg:gap-y-0 py-[62px]"
      >
        <div>

          <a :href="addUtm('/about-us')" class="font-madera-medium text-forest hover:underline"> About Us </a>
          <div class="mt-6 flex flex-col gap-4">
            <a :href="addUtm('/about-us/our-isa-and-sipp')" class="small-text-1-reg text-off-black hover:underline" target="_blank">
              Our ISA &amp; SIPP
            </a>
            <a :href="addUtm('/about-us/our-advisers')" class="small-text-1-reg text-off-black hover:underline" target="_blank">
              Our Advisers
            </a>
            <a :href="addUtm('/about-us/testimonials')" class="small-text-1-reg text-off-black hover:underline" target="_blank">
              Testimonials
            </a>
          </div>
        </div>

        <div>
          <a :href="addUtm('/investment-advice')" class="font-madera-medium text-forest hover:underline" target="_blank">
            Investment Advice
          </a>
        </div>

        <div>
          <a :href="addUtm('/retirement-planning')" class="font-madera-medium text-forest hover:underline" target="_blank">
            Retirement Planning
          </a>
          <div class="mt-6 flex flex-col gap-4">
            <a
              :href="addUtm('/retirement-planning/defined-benefit-pensions')"
              class="small-text-1-reg text-off-black hover:underline"
              target="_blank"
            >
              Defined Benefit Pensions
            </a>
          </div>
        </div>

        <div>
          <a :href="addUtm('/news')" class="font-madera-medium text-forest hover:underline" target="_blank"> News </a>
        </div>

        <div>
          <a :href="addUtm('/get-in-touch')" class="font-madera-medium text-forest hover:underline" target="_blank"> Get in Touch </a>
        </div>

        <div>
          <div class="font-madera-medium text-forest">
            Useful Links
          </div>
          <div class="flex flex-col gap-4 mt-6">
            <a :href="addUtm('/privacy-notice')"
              target="_blank"
              class="small-text-1-reg text-off-black hover:underline">
              Privacy
            </a>
            <a
              :href="addUtm('/useful-links/cookies-policy')"
              target="_blank"
              class="small-text-1-reg text-off-black hover:underline">
              Cookies Policy
            </a>
            <a
              :href="addUtm('/useful-links/disclaimer')"
              target="_blank"
              class="small-text-1-reg text-off-black hover:underline">
              Disclaimer
            </a>
            <a
              :href="addUtm('/useful-links/faqs')"
              target="_blank"
              class="small-text-1-reg text-off-black hover:underline">
              FAQs
            </a>
            <a
              :href="addUtm('/useful-links/glossary')"
              target="_blank"
              class="small-text-1-reg text-off-black hover:underline">
              Glossary
            </a>
            <a
              :href="addUtm('/useful-links/accessibility')"
              target="_blank"
              class="small-text-1-reg text-off-black hover:underline">
              Accessibility
            </a>
            <a
              :href="addUtm('/useful-links/how-to-make-a-complaint')"
              target="_blank"
              class="small-text-1-reg text-off-black hover:underline">
              How To Make A Complaint
            </a>
          </div>
        </div>
      </div>

      <div class="pt-[62px] flex flex-col gap-y-8 lg:gap-y-0 lg:flex-row sm:items-center sm:justify-between">
        <p class="caption">Copyright {{ (new Date()).getFullYear() }} Wealth at Work Limited. All rights reserved.</p>
        <!-- App downloads -->
        <div class="flex flex-row justify-start sm:items-center gap-x-8 sm:gap-x-12">
          <a
            href="/useful-links/app-download"
            aria-label="Download the app"
            target="_blank"
          >
            <img :src="`${cdn}/Icons/MWP-app.svg`" alt="App icon">
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.wealth_at_work.mobile_app.prod&pli=1"
            target="_blank"
            aria-label="Download on the google play app store link"
          >
            <img :src="`${cdn}/Icons/google-play.svg`" alt="Google play icon">
          </a>
          <a
            href="https://apps.apple.com/gb/app/my-wealth-invest/id6443942288"
            target="_blank"
            aria-label="Download on the apple app store link"
          >
            <img :src="`${cdn}/Icons/apple-store.svg`" alt="Apple store icon">
          </a>
          <a
            href="https://twitter.com/_mywealth"
            target="_blank"
          >
            <img :src="`${cdn}/Icons/x.svg`" alt="X.com logo">
          </a>
        </div>
      </div>
    </div>
  </section>
</template>
